import { Chip as MUIChip, ChipProps, styled } from "@mui/material";

interface IChip extends ChipProps {
  type?: "rounded" | "normal";
  active?: boolean;
  inActive?: boolean;
  label?: string | React.ReactNode | number | JSX.Element;
}

const StyledChip = styled(MUIChip)<IChip>(
  ({ theme: { palette }, active, type, inActive }) => ({
    cursor: "pointer",
    fontSize: ".75rem",
    color: palette.theme?.secondary[800],
    borderRadius: type === "rounded" ? "1.5rem" : "0.25rem",
    backgroundColor: palette.theme?.secondary[200],
    ...(active && {
      "&.MuiChip-filled": {
        color: palette.theme?.primary[700],
        backgroundColor: palette.theme?.primary[200],
        "&:hover": {
          backgroundColor: palette.theme?.primary[200]
        },
      },
      "&.MuiChip-outlined": {
        color: palette.theme?.primary[800],
        borderColor: palette.theme?.primary[300],
        "&:hover": {
          backgroundColor: palette.theme?.primary[200]
        },
      },
    }),
    ...(inActive && {
      "&.MuiChip-filled": {
        color: palette.theme?.error[700],
        backgroundColor: palette.theme?.error[200],
        "&:hover": {
          backgroundColor: palette.theme?.error[200]
        },
      },
      "&.MuiChip-outlined": {
        color: palette.theme?.error[800],
        borderColor: palette.theme?.error[300],
        "&:hover": {
          backgroundColor: palette.theme?.error[200]
        },
      },
    }),

    "& .MuiChip-icon": {
      marginRight: "0.125rem",
      marginLeft: "0rem",
      color: "inherit",
    },
    "& .MuiChip-deleteIcon": {
      marginLeft: "0.25rem",
      fontSize: ".875rem",
      color: "inherit",
      marginRight: "0rem",
    },
    "&.MuiChip-root": {
      height: "fit-content",
      padding: "0.25rem 0.5rem",
      ".MuiChip-label": {
        padding: "0rem",
      },
    },
  }),
);

const Chip = (props: IChip) => {
  const {
    label,
    type = "rounded",
    variant = "filled",
    active = false,
    inActive = false,
    ...rest
  } = props;

  return (
    <StyledChip
      label={label}
      variant={variant}
      active={active}
      inActive={inActive}
      type={type}
      {...rest}
    />
  );
};

export { Chip };
export default Chip;
